export default (account) => account.roles.includes("admin") || account.roles.includes("superadmin");